
<template>
	<div class="search-bar">
		<template v-if="showSearchInput">
			<div class="search-bar__filters-toggle-wrapper">
				<button
					class="search-bar__filters-toggle"
					:class="show_filters ? 'search-bar__filters-toggle--toggled': 'search-bar__filters-toggle--untoggled'"
					@click="show_filters = !show_filters"
				>
					{{ show_filters ? 'Close filter' : 'Filter' }}{{ total_filter_count ? ' (' + total_filter_count + ')' : '' }}
				</button>
			</div>
			<div
				class="search-bar__field a4-12"
				@click="focusSearch"
			>
				<input
					ref="search_filter_input"
					v-model="search_query"
					class="search__input"
					type="text"
					:placeholder="inputPlaceholder"
					@input="handleSearchInputChange"
				>
			</div>
		</template>

		<p class="search-bar__count">
			Showing {{ pagination.total_count }} result{{ pagination.total_count === 1 ? '' : 's' }}
		</p>

		<template
			v-if="props.storeKey === 'database'"
		>
			<DatabaseSortingAndDateFilterComponent />
		</template>
		<template
			v-else
		>
			<ProjectSortingAndDateFilterComponent
				v-if="active_tab !== 'example_projects'"
			/>
		</template>
	</div>
</template>

<script setup>
import { ref, nextTick, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { useDatabaseFiltersStore } from '../../stores/database-filters';
import { useProjectFiltersStore } from '../../stores/project-filters';
import ProjectSortingAndDateFilterComponent from './ProjectSortingAndDateFilterComponent';
import DatabaseSortingAndDateFilterComponent from './DatabaseSortingAndDateFilterComponent';

const props = defineProps( {
	storeKey: {
		type: String,
		default: 'projects',
	},
	showSearchInput: {
		type: Boolean,
		default: true,
	},
	inputPlaceholder: {
		type: String,
		default: 'Search',
	},
} );

const filters_store = props.storeKey === 'database' ? useDatabaseFiltersStore() : useProjectFiltersStore();

const {
	resetPagination,
	updateQueryStringFromFilters
} = filters_store;

const {
	active_tab,
	show_filters,
	search_query,
	pagination,
	total_filter_count
} = storeToRefs( filters_store );

// Project search
const search_filter_input = ref( null );

const handleSearchInputChange = async( e ) => { // eslint-disable-line snakecasejs/snakecasejs
	const input = e.target.value;
	setTimeout( async() => {
		if ( search_query.value === input ) {
			resetPagination();
			await nextTick();
			updateQueryStringFromFilters();
		}
	}, 500 );
};

const focusSearch = () => { // eslint-disable-line snakecasejs/snakecasejs
	search_filter_input.value.focus();
};
</script>